import { PetitionsHistoryPageModule } from './../pages/petitions-history/petitions-history.module';
import { PetitionsStatePageModule } from './../pages/petitions-state/petitions-state.module';
import { ReportMonthPageModule } from './../pages/report-month/report-month.module';
import { ReportGlobalPageModule } from './../pages/report-global/report-global.module';
import { AnnulmentsPageModule } from './../pages/annulments/annulments.module';
import { PetitionHourCompensationPageModule } from './../pages/petition-hour-compensation/petition-hour-compensation.module';
import { WorkDaysPageModule } from './../pages/work-days/work-days.module';
import { TasksPageModule } from './../pages/tasks/tasks.module';
import { LoginPageModule } from './../pages/login/login.module';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { MyApp } from './app.component';
import { FIREBASE_CONFIG } from './app.firebase.config';
import { Firebase } from '@ionic-native/firebase';

import { HomePageModule } from './../pages/home/home.module';
import { MailboxPageModule } from './../pages/mailbox/mailbox.module';
import { ConfigurationPageModule } from '../pages/configuration/configuration.module';
import { AreasPageModule } from '../pages/areas/areas.module';

import { CalendarModule } from "ion2-calendar";
import { GlobalVars } from './app.environment';
import { SMS } from '@ionic-native/sms';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener'
import { SplashScreen } from '@ionic-native/splash-screen';
import { AppUpdate } from '@ionic-native/app-update';
import { AppVersion } from '@ionic-native/app-version';

import { AuthProvider } from '../providers/auth/auth';
import { FirebaseProvider } from '../providers/firebase/firebase';
import { UserProvider } from '../providers/user/user';
import { ConfigurationProvider } from '../providers/configuration/configuration';
import { PetitionProvider } from '../providers/petition/petition';
import { UsersPageModule } from '../pages/users/users.module';
import { AreaProvider } from '../providers/area/area';
import { PetitionAbsencePageModule } from '../pages/petition-absence/petition-absence.module';
import { WorkDaysProvider } from '../providers/work-days/work-days';
import { PetitionExtraHoursPageModule } from '../pages/petition-extra-hours/petition-extra-hours.module';
import { CoefficientProvider } from '../providers/coefficient/coefficient';
import { ReportProvider } from '../providers/report/report';
import { ReportSelectionPageModule } from '../pages/report-selection/report-selection.module';
import { ReportUserPageModule } from '../pages/report-user/report-user.module';
import { NotificationProvider } from '../providers/notification/notification';

@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    CalendarModule,
    IonicModule.forRoot(MyApp, {
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    }),
    AngularFireModule.initializeApp(FIREBASE_CONFIG),
    AngularFireAuthModule,
    AngularFireDatabaseModule,

    AnnulmentsPageModule,
    HomePageModule,
    MailboxPageModule,
    LoginPageModule,
    ConfigurationPageModule,
    AreasPageModule,
    UsersPageModule,
    PetitionAbsencePageModule,
    TasksPageModule,
    WorkDaysPageModule,
    PetitionExtraHoursPageModule,
    PetitionHourCompensationPageModule,
    ReportSelectionPageModule,
    ReportGlobalPageModule,
    ReportUserPageModule,
    ReportMonthPageModule,
    PetitionsStatePageModule,
    PetitionsHistoryPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  providers: [
    AppUpdate,
    AppVersion,
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    GlobalVars,
    SMS,
    File,
    FileOpener,
    Firebase,
    
    AuthProvider,
    FirebaseProvider,
    UserProvider,
    ConfigurationProvider,
    PetitionProvider,
    AreaProvider,
    WorkDaysProvider,
    CoefficientProvider,
    ReportProvider,
    NotificationProvider,
  ],

})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts